'use strict';

export default function PriceToKStringListFilter() {
  return function (price) {
    var result = price;

    if (isNaN(result) || result == null) {
      return '';
    }

    if (result === true) {
      return '<1K';
    }

    if (result === 0) {
      return '<1K';
    }

    if (result > 999999) {
      return Math.floor(result / 100000) / 10 + 'M';
    } else if (result > 999) {
      return Math.floor(result / 1000) + 'K';
    } else {
      return '<1K';
    }
  };
}
